import {
  ILabelStyles,
  ILinkStyles,
  IStackStyles,
  IButtonStyles,
  IDropdownStyles,
  ISliderStyles,
  concatStyleSets
} from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../../common/styles/common.styles';

export const getAppAudioPlayerRootStackCSSProperties = (): React.CSSProperties => {
  const CSSProperties: React.CSSProperties = {
    padding: '0 16px 0 16px',
    boxSizing: 'border-box',
    width: '100%'
  };

  return CSSProperties;
};

export const getAppAudioBarContainerCSSProperties = (): React.CSSProperties => {
  const CSSProperties: React.CSSProperties = {
    padding: '12px 0 12px 0',
    width: '100%'
  };

  return CSSProperties;
};

const getAppAudioPlayerTitleSpecificStyles = (): ILabelStyles => {
  return {
    root: {
      padding: '0px 0px 8px 0px',
      alignSelf: 'start',
      width: '90%',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  };
}

export const getAppAudioPlayerTitleLabelStyles = (): ILabelStyles => {
  const commonLabelStyles = AppLayoutSettings.AppCommonStyles.getBoldLabelStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx, AppLayoutSettings.getAppColorContainer().mediumLabelColor);
  const specificStyle = getAppAudioPlayerTitleSpecificStyles();

  return concatStyleSets(commonLabelStyles, specificStyle);
};

export const getAppAudioPlayerTitleLinkStyles = (): ILinkStyles => {
  const commonLinkStyles = AppLayoutSettings.AppCommonStyles.getLinkStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx, AppLayoutSettings.getAppColorContainer().linkColor);
  const specificStyle = getAppAudioPlayerTitleSpecificStyles();

  return concatStyleSets(commonLinkStyles, specificStyle);
};

export const audioPlayerStackStyles: IStackStyles = {
  root: {
    width: '100%',
    padding: '8px 0px 8px 0px'
  }
};

export const getAppAudioPlayerDropDownStyles = (): Partial<IDropdownStyles> => {
  return {
    root: {
      width: '50px',
      background: 'transparent',
      selectors: {
        [`:focus, :active, :hover`]: {
          background: AppLayoutSettings.getAppColorContainer().lightBackgroundColor.value
        }
      }
    },
    title: {
      background: 'transparent',
      border: 'none',
      padding: 0,
      textAlign: 'center',
      textOverflow: 'nowrap',
      fontSize: AppLayoutSettings.AppFontSize.extraLargePlusFontSizePx,
      //Note: !important is used to disable the hover state color change of dropdown title. Otherwise, the text color is getting dark and unreadable in dark mode.
      color: `${AppLayoutSettings.getAppColorContainer().mediumLabelColor.value} !important`,
    },
    dropdown: {
      selectors: {
        [`:focus::after`]: {
          zIndex: 1,
          border: '1px solid transparent',
          outline: '1px solid',
          outlineColor: AppLayoutSettings.getAppColorContainer().keyboardFocusColor.value
        }
      }
    },
    dropdownItem: {
      color: AppLayoutSettings.getAppColorContainer().mediumLabelColor.value,
      backgroundColor: AppLayoutSettings.getAppColorContainer().secondaryWidgetColor.value,
    },
    caretDownWrapper: {
      visibility: 'hidden'
    },
  };
};

export const getAppAudioPlayerButtonStyles = (): Partial<IButtonStyles> => {
  return {
    root: {
      minWidth: '50px',
      padding: 0,
      background: 'transparent',
      border: 'none'
    },
    flexContainer: {
      background: 'transparent',
      selectors: {
        [`:focus, :active, :hover`]: {
          background: AppLayoutSettings.getAppColorContainer().lightBackgroundColor.value
        }
      }
    },
    icon: {
      fontSize: '20px',
      color: AppLayoutSettings.getAppColorContainer().mediumLabelColor.value
    }
  };
};

export const getVolumeCalloutContainersCSSProperties = (): React.CSSProperties => {
  const CSSProperties: React.CSSProperties = {
    flexDirection: 'row',
    display: 'flex',
    height: '52px',
    width: '248px',
    padding: '4px 8px 4px 8px',
    boxSizing: 'border-box',
    background: AppLayoutSettings.getAppColorContainer().whiteColor.value
  };

  return CSSProperties;
};

export const getVolumeCalloutIconCSSProperties = (): React.CSSProperties => {
  const CSSProperties: React.CSSProperties = {
    padding: '14px 8px 14px 8px',
    background: AppLayoutSettings.getAppColorContainer().whiteColor.value,
    fontSize: AppLayoutSettings.AppFontSize.extraLargeFontSizePx,
    color: AppLayoutSettings.getAppColorContainer().mediumLabelColor.value
  };

  return CSSProperties;
};

export const getVolumeCalloutSliderStyles = (): Partial<ISliderStyles> => {
  return {
    container: {
      height: '100%',
      width: '168px'
    },
    activeSection: {
      background: AppLayoutSettings.getAppColorContainer().linkColor.value
    },
    slideBox: {
      padding: '0px 8px 0px 0px'
    }
  };
};
